<template>
  <p
    class="u-margin-top-tiny u-margin-bottom-none u-medium t-color--light"
    v-if="hasSavedSearch"
  >
    {{ $label('lastSearch') }}:
    <a href="#" @click.prevent="onLastSearchClicked" @click="updateLastInteracted()">
      <span v-html="savedSearchLabel"></span>
    </a>
  </p>
</template>

<script>
import { mapGetters } from 'vuex'
import FilterLabelService from '@/services/FilterLabelService.js'

export default {
  name: 'SavedSearch',
  computed: Object.assign(mapGetters(['savedSearch']), {
    hasSavedSearch() {
      return this.savedSearch !== null
    },
    savedSearchLabel() {
      if (this.hasSavedSearch) {
        if (this.savedSearch.s !== '') {
          return this.savedSearch.s
        } else {
          return FilterLabelService.allFiltersLabel(this.savedSearch)
        }
      }

      return ''
    },
  }),
  methods: {
    updateLastInteracted() {
      localStorage.setItem('last_interacted', 'Previous search')
    },
    onLastSearchClicked() {
      this.$store.dispatch('executeLastSearch')
    },
  },
}
</script>
